var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 162,
    viewBox: "0 0 160 162",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)",
    stroke: "#000",
    strokeWidth: 10,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74,
    cy: 40,
    rx: 39,
    ry: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 151.5c18.66-28.237 43.493-42.356 74.5-42.356 31.007 0 55.84 14.119 74.5 42.356",
    strokeLinecap: "round"
  }))));
}

export default SvgAvatarDark;